import React, { Component } from 'react';
import styled from 'styled-components';
import LoginModal from './LoginModal';

const Heading = styled.div`
  width: 100%;
  margin-top: 30px;
  height: 42px;
  background-color: 'transparent';
  display: flex;
  justify-content: space-between;
`;
const Logo = styled.img`
  margin: auto 0;
  width: 130px;
  height: auto;
  opacity: 0.65;
`;

const HeaderText = styled.p`
  width: 30%;
  font-size: 1.8em;
  font-family: HelveticaNeueLTPro-Roman;
  font-weight: lighter;
  text-transform: none;
  letter-spacing: 0.5px;
`;

const Login = styled.a`
  text-decoration: underline;
  font-size: 15px;
  cursor: pointer;
`;

const DealerName = styled.a`
  display: block;
  margin: 20px 0 0 0;
  font-size: 16px;
  line-height: 0;
`;

const HeaderP = styled.p`
  margin: 0;
  line-height: 0;
`;

export default class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalOpen: false,
      modalData: {},
      dealeremail: '',
      dealername: '',
      timestamp: '',
      login: false,
    };
    this.closeModal = this.closeModal.bind(this);
    this.openModal = this.openModal.bind(this);
    this.signOutHandler = this.signOutHandler.bind(this);
  }

  componentDidMount() {
    const dealeremail = localStorage.getItem('dealeremail');
    const dealername = localStorage.getItem('dealername');
    const info = { dealeremail, dealername };
    if (dealeremail && dealername) {
      this.loginHandler(info);
    }
  }

  openModal() {
    const options = [
      { label: 'Dealer Name', value: 'dealername' },
      { label: 'Dealer Email', value: 'dealeremail' },
    ];
    const modalData = { options };
    this.setState({ modalOpen: true, modalData });
  }

  closeModal() {
    this.setState({ modalOpen: false });
  }

  loginHandler = info => {
    const { dealeremail, dealername } = info;
    const time = new Date().toDateString();
    localStorage.setItem('dealeremail', dealeremail);
    localStorage.setItem('dealername', dealername);
    this.setState({
      dealeremail,
      dealername,
      timestamp: time,
      modalOpen: false,
      login: true,
    });
  };

  signOutHandler() {
    localStorage.removeItem('dealeremail');
    localStorage.removeItem('dealername');
    this.setState({
      dealeremail: '',
      dealername: '',
      timestamp: '',
      login: false,
    });
  }

  render() {
    const { modalData, modalOpen, login, dealername } = this.state;
    return (
      <Heading>
        <Logo src="/img/logo.jpeg" />
        <HeaderText>
          <HeaderP>My SILQ Styler</HeaderP>
          <div
            style={{
              lineHeight: '28px',
              marginTop: dealername ? '25px' : '10px',
            }}
          >
            {dealername && <DealerName>Hello, {dealername}</DealerName>}
            <Login onClick={login ? this.signOutHandler : this.openModal}>
              {login ? 'Sign Out' : 'Log In'}
            </Login>
          </div>
        </HeaderText>
        <LoginModal
          open={modalOpen}
          closeModal={this.closeModal}
          data={modalData}
          actionFn={this.loginHandler}
        />
      </Heading>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Header.js